import "core-js/modules/es.array.includes.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dd526a58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "F3DScaleBRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "按左侧图形逐行寻找（每行左侧的图形不相同），并点选每个目标图形左侧的方格。规定☆为特殊图形，若☆后的图形为所寻找图形，则点选每个目标图形右侧的方格", -1));
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center mt16"
};
const _hoisted_6 = {
  key: 0,
  class: "text-yellow-500"
};
const _hoisted_7 = {
  key: 1,
  class: "text-green-500"
};
const _hoisted_8 = {
  key: 2,
  class: "text-red-500"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_F3DScaleAItem = _resolveComponent("F3DScaleAItem");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.question.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _hoisted_4, (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], line => {
    return _createElementVNode("div", {
      key: `line${line}`,
      class: "flex items-center justify-center mt-4"
    }, [_createElementVNode("span", null, _toDisplayString(line + 1) + "、", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.questions[line], (q, qi) => {
      return _openBlock(), _createBlock(_component_F3DScaleAItem, {
        key: `${line}_q${qi}`,
        "img-idx": q,
        "answer-mode": false,
        "show-idx": false,
        subject: "B"
      }, null, 8, ["img-idx"]);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.answers[line], (a, ai) => {
      return _openBlock(), _createBlock(_component_F3DScaleAItem, {
        key: `${line}_a${ai}`,
        "img-idx": a,
        idx: $props.question.flags[line][ai] > 0 ? -1 * (line * 20 + ai) : line * 20 + ai,
        "show-idx": line < 1,
        flag: $props.question.flags[line][ai],
        highlight: $props.reviewMode && $props.question.rightAnswerPos.includes(line * 20 + ai),
        choosed: $props.reviewMode ? $options.getChooseOf($props.review?.answer, line * 20 + ai) : 0,
        "answer-mode": !$props.reviewMode,
        "show-box": $props.reviewMode,
        onClearChoose: $options.clearChoose,
        onChoosed: $options.onAnswerChoosed,
        subject: "B"
      }, null, 8, ["img-idx", "idx", "show-idx", "flag", "highlight", "choosed", "answer-mode", "show-box", "onClearChoose", "onChoosed"]);
    }), 128))]);
  }), 64)), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [!$props.review ? (_openBlock(), _createElementBlock("span", _hoisted_6, "本题未作答")) : $props.review.result ? (_openBlock(), _createElementBlock("span", _hoisted_7, "本题回答正确")) : !$props.review.result ? (_openBlock(), _createElementBlock("span", _hoisted_8, "本题回答错误")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}